import styled, { css } from 'styled-components';
import CheckImg from 'assets/img/icons/checkmark.svg';
import { th, variants } from 'style/theme';

export const CheckboxContainer = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  position: relative;
  margin-bottom: 0px;
  line-height: 10px;
  vertical-align: middle;
`;

export const Icon = styled.img.attrs({ alt: '✓', src: CheckImg })`
  position: absolute;
  width: 25px;
  height: 25px;
  bottom: 0px;
  left: -1px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div`
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  background: #fff;
  border: ${(props) =>
    props.checked ? 'none' : `1px solid ${props.theme.colors.silverLightGray}`};
  border-radius: 4px;
  transition: all 150ms;
  margin-right: ${({ hasChildren }) => (hasChildren ? '8px' : '0')};

  > ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }

  > svg {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
    fill: ${th('colors.fountainBlue')};
    width: 20px;
    height: 20px;
  }

  ${variants('variant', {
    transparentWhite: css`
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.5);
      border: ${(props) =>
        props.checked ? 'none' : `1px solid ${props.theme.colors.white}`};
    `
  })};
`;

export const Text = styled.div``;
